module.exports = __webpack_public_path__ + "static/julia-4adc0a93359299c47562ccff53a9e831.webp";